import { render, staticRenderFns } from "./basic-spinner.vue?vue&type=template&id=dcf1d1de&scoped=true"
import script from "./basic-spinner.vue?vue&type=script&lang=js"
export * from "./basic-spinner.vue?vue&type=script&lang=js"
import style0 from "./basic-spinner.vue?vue&type=style&index=0&id=dcf1d1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf1d1de",
  null
  
)

export default component.exports